import { SettingOutlined } from "@ant-design/icons";
import { Button, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import styles from "./complianceHeader.module.scss";

const ComplianceDashboardHeader = () => {
  const navigate = useNavigate();
  return (
    <Flex justify="space-between" align="flex-start" gap={16} wrap="wrap" className={styles.header}>
      <Flex vertical gap={4}>
        <div className={styles.header__title}>Compliance Dashboard</div>
        <div className={styles.header__subtitle}>Triage findings, coach clinicians, and manage compliance rules.</div>
      </Flex>
      <div className={styles.header__actions}>
        <Button type="primary" icon={<SettingOutlined />} onClick={() => navigate("/compliance/manage-rules")}>
          Manage Rules
        </Button>
      </div>
    </Flex>
  );
};

export default ComplianceDashboardHeader;
